<!-- <div class="container-fluid px-2">
  <app-pagetitle
    title="Operator Mapping"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>


  <div class="row" *ngIf="departments.length">
    <div class="form-group col-md-3">
      <label>Select Department</label>

      <select
        class="form-control"
        [(ngModel)]="selecteddepartmentName"
        (change)="departmentChange(selecteddepartmentName)"
      >
        <option value="" disabled>Select Department</option>

        <option
          *ngFor="let dept of departments"
          [value]="dept.departmentName"
        >
          {{ dept.departmentName }}
        </option>
      </select>
    </div>
  </div>


  <div class="row mt-2" *ngIf="devicelistData.length">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body p-2">

          <div style="overflow-x:auto;">
            <table class="table table-bordered table-striped">

              <thead class="table-dark">
                <tr>
                  <th>Machine</th>

                  <th *ngFor="let shift of selectedDepartment?.shiftData">
                    {{ shift.shiftName }}
                  </th>
                </tr>
              </thead>

            
              <tbody>
                <tr *ngFor="let device of devicelistData">
                  <td>{{ device.deviceName }}</td>

                  <td *ngFor="let shift of selectedDepartment?.shiftData">
                    <select
                      class="form-control form-control-sm"
                      [(ngModel)]="selectedOperators[device.deviceId][shift.shiftName]"
                      (change)="onOperatorChange(device, shift)"
                    >
                      <option
                        *ngFor="let op of operator"
                        [value]="op.id"
                      >
                        {{ op.name }}
                      </option>
                    </select>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>

        </div>
      </div>
    </div>
  </div>


  <div class="card mt-2" *ngIf="!devicelistData.length">
    <div class="p-2">
      <strong>No Machines Found. Please Add Machine</strong>
    </div>
  </div>
</div> -->


<div class="container-fluid px-2" (click)="closeAllDropdowns()">
  <app-pagetitle
    title="Operator Mapping"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>

  <div class="row" *ngIf="departments.length">
    <div class="form-group col-md-3">
      <label>Select Department</label>
      <select
        class="form-control"
        [(ngModel)]="selecteddepartmentName"
        (change)="departmentChange(selecteddepartmentName)"
      >
        <option value="" disabled>Select Department</option>
        <option *ngFor="let dept of departments" [value]="dept.departmentName">
          {{ dept.departmentName }}
        </option>
      </select>
    </div>
  </div>

  <div class="row mt-2" *ngIf="devicelistData.length">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body p-2">
          <div style="overflow-x: auto;">
            <table class="table table-bordered table-striped">
              <thead class="table-dark">
                <tr>
                  <th style="width: 35%;">Machine</th>
                  <th>Operators</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let device of devicelistData">
                  <td>{{ device.deviceName }}</td>
                  <td>
                    <div
                      class="multi-select-wrapper"
                      style="position: relative;"
                      (click)="$event.stopPropagation()"
                    >
                      <div
                        class="form-control form-control-sm d-flex justify-content-between align-items-center"
                        style="cursor: pointer; user-select: none;"
                        (click)="toggleDropdown(device.deviceId)"
                      >
                        <span
                          class="text-truncate"
                          style="max-width: 90%; font-size: 0.85rem;"
                          [class.text-muted]="!(selectedOperators[device.deviceId]?.length)"
                        >
                          {{ getSelectedNames(device.deviceId) }}
                        </span>
                        <i
                          class="mdi"
                          [class.mdi-chevron-down]="!dropdownOpen[device.deviceId]"
                          [class.mdi-chevron-up]="dropdownOpen[device.deviceId]"
                        ></i>
                      </div>

                      <div
                        *ngIf="dropdownOpen[device.deviceId]"
                        class="border bg-white shadow-sm rounded"
                        style="
                          position: absolute;
                          top: 100%;
                          left: 0;
                          z-index: 1050;
                          min-width: 100%;
                          max-height: 200px;
                          overflow-y: auto;
                        "
                      >
                        <div
                          *ngFor="let op of operator"
                          class="d-flex align-items-center px-3 py-2 dropdown-item-custom"
                          style="cursor: pointer; gap: 8px; font-size: 0.875rem;"
                          (click)="toggleOperator(device, op.id)"
                        >
                          <input
                            type="checkbox"
                            [checked]="isSelected(device.deviceId, op.id)"
                            (click)="$event.stopPropagation()"
                            style="cursor: pointer;"
                          />
                          <span>{{ op.name }}</span>
                        </div>

                        <div
                          *ngIf="!operator.length"
                          class="px-3 py-2 text-muted"
                          style="font-size: 0.85rem;"
                        >
                          No operators available
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-2" *ngIf="!devicelistData.length && departments.length">
    <div class="p-2">
      <strong>No Machines Found. Please Add Machine</strong>
    </div>
  </div>
</div>